<template>
    <div class="stats-grid" :style="gridStyle">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'StatsGrid',
    props: {
        columns: {
            type: [String, Number],
            default: 3,
        },
        expanded: {
            type: Number,
            default: null,
        },
        rowHeight: {
            type: [String, Number],
            default: 340,
        },
        expandedRowHeight: {
            type: [String, Number],
            default: 520,
        },
        count: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        columnCount(vm = this) {
            return Math.max(1, Number(vm.columns) || 1)
        },
        rowCount(vm = this) {
            return Math.max(1, Math.ceil((vm.count || 0) / vm.columnCount))
        },
        gridStyle(vm = this) {
            const style = { '--sg-row-h': `${vm.rowHeight}px` }
            if (vm.expanded == null) return style

            const column = vm.expanded % vm.columnCount
            const row = Math.floor(vm.expanded / vm.columnCount)

            style['--sg-cols'] = Array.from({ length: vm.columnCount }, (_, i) => i === column ? '2fr' : '1fr').join(' ')
            style['--sg-rows'] = Array.from({ length: vm.rowCount }, (_, i) => {
                return `${i === row ? vm.expandedRowHeight : vm.rowHeight}px`
            }).join(' ')

            return style
        },
    },
}
</script>

<style scoped>
.stats-grid {
    display: grid;
    gap: 14px;
    grid-template-columns: var(--sg-cols, repeat(3, 1fr));
    grid-template-rows: var(--sg-rows, none);
    grid-auto-rows: var(--sg-row-h, 340px);
}

@media (max-width: 1100px) {
    .stats-grid {
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: none;
    }
}

@media (max-width: 700px) {
    .stats-grid {
        grid-template-columns: 1fr;
        grid-template-rows: none;
        grid-auto-rows: minmax(var(--sg-row-h, 340px), auto);
    }
}
</style>
